import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';
import { useState } from 'react';
import { useDeletePieceMutation } from 'src/redux/api/piece';
import DefaultIconWithLoader from './components/DefaultIconWithLoader';
import { CaptureId } from '../../types';

type Props = {
  tooltip?: string;
  disabled?: boolean;
  onClick: (id: number) => void;
  id?: CaptureId | null;
}

const DeleteIcon = ({ tooltip, disabled, onClick, id }: Props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [deletePiece, { isLoading: isDeleteLoading }] = useDeletePieceMutation();
  return (
    <>
      <DefaultIconWithLoader
        Icon={DeleteOutline}
        tooltip={tooltip}
        disabled={disabled}
        onClick={() => setIsDialogOpen(true)}
      />
      <DialogConfirmation
        maxWidth="xs"
        open={isDialogOpen}
        loading={isDeleteLoading}
        handleClose={() => setIsDialogOpen(false)}
        type="error"
        title="Delete item"
        content={'Are you sure you would like to permanently delete this item?'}
        acceptButtonTitle="Delete"
        acceptButtonHandleClick={async () => {
          if (!id) return;
          await deletePiece(+id)
          onClick(+id);
          setIsDialogOpen(false);
        }}
        cancelButtonTitle="Cancel"
        cancelButtonHandleClick={() => setIsDialogOpen(false)}
      />
    </>
  );
}

export default DeleteIcon;